import React, { useEffect, useState } from "react";
import "./TransferAirdrop.css";
import Loader from "../../Components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { ApiPaths } from "../../Config/ApiPath";
import useAxiosHelper from "../../Common/AxiosHelper";
import { BasicInfo, toastFailed, toastSuccess } from "../../Config/BasicInfo";
import { Calendar, Clock, ArrowLeft, X } from "lucide-react";

const TransferAirdrop = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [username, setUsername] = useState("");
  const [existUserName, setExistUserName] = useState({});
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [companyData, setCompanyData] = useState({});
  const { AxiosPost, AxiosGet } = useAxiosHelper();
  const [load, setLoad] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    CompanyInfo();
  }, []);

  async function CompanyInfo() {
    try {
      const res = await AxiosGet(ApiPaths.companyInfo);
      if (res) {
        setCompanyData(res);
      }
    } catch (error) {
      console.error("Error fetching company info:", error);
    }
  }

  const isUserExist = async () => {
    setLoad(true);

    if (!username) {
      setExistUserName({ name: ". . .", color: "var(--textColor)" });
      setLoad(false);
      return;
    }
    try {
      setLoad(true);
      const body = {
        username: username,
      };
      console.log("body", body);
      const res = await AxiosPost(ApiPaths.checkSponsor, body);
      if (res) {
        setExistUserName({ name: res.name, color: "var(--colorSuccess)" });
      } else {
        // User not found
      }
    } catch (e) {
      setExistUserName({ name: "User not exists", color: "var(--redIcon)" });
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setTypingTimeout(
      setTimeout(() => {
        isUserExist();
      }, 1000) // 1 second debounce delay
    );
    return () => clearTimeout(typingTimeout);
  }, [username]);

  const validateForm = () => {
    if (!username || username.length === 0) {
      toastFailed("Please enter a username");
      return false;
    }
    if (existUserName?.color !== "var(--colorSuccess)") {
      toastFailed("Please enter a valid username");
      return false;
    }
    if (!amount || amount <= 0) {
      toastFailed("Please enter a valid amount");
      return false;
    }
    return true;
  };

  const handleProceed = () => {
    if (validateForm()) {
      setShowConfirmation(true);
    }
  };

  const handleConfirmTransfer = async () => {
    try {
      setLoading(true);
      const body = {
        username: username,
        amount: amount,
      };
      console.log("Transfer body:", body);
      
      // TODO: Replace with actual API endpoint for airdrop transfer
      // const res = await AxiosPost(ApiPaths.transferAirdrop, body);
      
      toastSuccess("Airdrop transfer initiated successfully!");
      setShowConfirmation(false);
      setUsername("");
      setAmount("");
      setExistUserName({});
    } catch (error) {
      toastFailed(error?.message || "Transfer failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}

      {/* Confirmation Popup */}
      {showConfirmation && (
        <div className="modal-backdrop">
          <div className="turboBoostModalSection" style={{ maxWidth: "400px" }}>
            <button
              className="modalCloseBtn"
              onClick={() => setShowConfirmation(false)}
            >
              &times;
            </button>
            <div>
              <h2
                className="incomeHistoryTableTitle"
                style={{ textAlign: "center", marginBottom: 18 }}
              >
                Confirm Transfer
              </h2>
              <div
                className="modal-info"
                style={{ textAlign: "center", marginBottom: 18 }}
              >
                <span
                  style={{
                    display: "block",
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: 8,
                  }}
                >
                  Are you sure you want to transfer airdrop?
                </span>
                <div style={{ textAlign: "left", marginTop: "20px" }}>
                  <p><strong>Username:</strong> {username}</p>
                  <p><strong>Amount:</strong> {companyData?.token_sign}{amount}</p>
                </div>
              </div>
              <div className="btnModalContainer">
                <button 
                  className="btnSecondary" 
                  onClick={() => setShowConfirmation(false)}
                  style={{ marginRight: "10px" }}
                >
                  Cancel
                </button>
                <button 
                  className="btnPrimary" 
                  onClick={handleConfirmTransfer}
                >
                  Confirm Transfer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <section className="dashboard">
        <div className="dashboardHeading">
          <div>
            <h1>Transfer Airdrop</h1>
            <h5>Transfer your airdrop tokens to another user</h5>
          </div>
          <div className="divTime">
            <div className="timeDashboard">
              <i>
                <Calendar style={{ height: "16px" }} />
              </i>
              <span>
                {currentTime.toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </div>
            <div className="timeDashboard">
              <i>
                <Clock style={{ height: "16px" }} />
              </i>
              <span>
                {currentTime.toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </span>
            </div>
          </div>
        </div>

        <div className="dashboardContent">
          <div className="addfundDiv inputPrimary">
            <div className="form-heading">
              <h3>Transfer Airdrop</h3>
            </div>
            <div className="registerInput_inner">
              <div className="d-flex justify-between">
                <label htmlFor="username">Username</label>
                <label
                  style={{
                    textAlign: "end",
                    color: existUserName?.color || "var(--textColor)",
                  }}
                  htmlFor="username"
                >
                  {load && username ? "Loading..." : existUserName?.name}
                </label>
              </div>
              <input
                type="text"
                id="username"
                name="username"
                placeholder="Enter Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <label htmlFor="amount">
              Amount ({companyData?.token_sign})
            </label>
            <input
              type="number"
              className="inputPrimary"
              placeholder="Enter Amount"
              style={{ borderRadius: "10px", padding: "8px 20px" }}
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
            <p className="errorMsg">{amountError}</p>

            <button 
              className="btnPrimary mt-3" 
              onClick={handleProceed}
              disabled={existUserName?.color !== "var(--colorSuccess)" || !amount || amount <= 0}
            >
              Proceed
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default TransferAirdrop;

